import { getAllCities  } from '@/services/endpoints/cities'
import { cities, countries } from '@/services/endpoints/locations'
import { getAllProvinces } from '@/services/endpoints/provinces'
import { getAllCountries } from '@/services/endpoints/countries'

export default {
    async cities({commit}, payload) {
        // return new Promise((resolve, reject) => {date-picker
        try {
            let res = await cities(payload);
            if (res) {
                // commit('SET_CITIES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async countries({commit}) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await countries();
            if (res) {
                commit('SET_COUNTRIES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getCountries({commit}, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getAllCountries();
            if (res) {

                // commit('SET_ISSUED_COUNTRIES', res.data)
                // commit('SET_COUNTRIES',res.data)
                // commit('patient/SET_COUNTRY',res.data.data[0],{root:true})
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getCities({ commit }, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getAllCities(payload);
            if (res) {
                commit('SET_CITIES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getProvinces({ commit }, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getAllProvinces(payload);
            if (res) {
                commit('SET_PROVINCES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    // async getIssuedCountries({ commit }, payload) {
    //     // return new Promise((resolve, reject) => {
    //     try {
    //         let res = await getAllCountries(payload);
    //         if (res) {
    //             commit('SET_ISSUED_COUNTRIES', res.data.data)
    //             return res.data
    //         }
    //     }
    //     catch (err) {
    //         
    //         throw new Error(err)
    //     }
    // },
    async getIssuedCities({ commit }, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getAllCities(payload);
            if (res) {
                commit('SET_ISSUED_CITIES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getBirthCities({ commit }, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getAllCities(payload);
            if (res) {
                commit('SET_BIRTH_CITIES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getIssuedProvinces({ commit }, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getAllProvinces(payload);
            if (res) {
                commit('SET_ISSUED_PROVINCES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}